import { Link } from '@trg/tlw-ui-component';
import type { AppStoreInfo } from '../../../api';

export interface DownloadLinkProps {
  downloadInfo?: AppStoreInfo;
}

export function DownloadLink({ downloadInfo }: DownloadLinkProps) {
  return (
    <Link href={downloadInfo?.link} target={downloadInfo?.linkTarget}>
      <img
        className="tlw-size-full"
        src={downloadInfo?.imageMediasUrl}
        alt={downloadInfo?.alt}
      />
    </Link>
  );
}
